import ProductIcon from '@mui/icons-material/Collections';
import { useTranslate } from 'react-admin';

import CardWithIcon from './CardWithIcon';

interface Props {
    value?: string;
}

const ActionRequestPending = (props: Props) => {
    const { value } = props;
    const translate = useTranslate();
    return (
        <CardWithIcon
            to='/requestForAction?filter={"sendToResponsibleForAnalysis":false}'
            icon={ProductIcon}
            title={translate('resources.dashboard.actionRequestPending')}
            subtitle={value}
        />
    );
};

export default ActionRequestPending;